export const secondsToHHMMSS = (seconds: number) => new Date(seconds * 1000).toISOString().slice(11, 19);

export const secondsToMMSS = (seconds: number) => new Date(seconds * 1000).toISOString().slice(14, 19);
